<template>
  <div>
    <CrudList
      title="Liquidaciones"
      storeName="Liquidations"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="false"
      :canDelete="true"
      :canExport="true"
      :canOther="true"
      labelOther="Pedidos de Liquidación"
      urlOther="request_extraction"
      :filters="filters"
      sortable
      :isRead="isRead"
      next-link="/admin/commissions/edit/general"
      :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/liquidations'
        },
        {
          text: 'Liquidaciones',
          disabled: false,
          href: '#'
        }
      ]"
    >
      <template v-slot:head-list="{}">
        <v-row>
          <v-col cols="3">
            <AutocompleteInput
                @selected="getAutocompleteUsers"
                :items="displayUsers"
                item-id="id"
                :is-multiple="true"
                item-text="full_name"
                label="Host"
                :loading="loadingUsers"
                :onSearch="onSearchUsers"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="data.item._loading">{{ data.item.full_name }}</span>
                    <span v-else>
                      {{ data.item.full_name }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </AutocompleteInput>
          </v-col>
          <v-col>
            <AutocompleteInput
                @selected="getAutocompleteSpots"
                :items="displaySpots"
                item-id="id"
                item-text="address"
                :is-multiple="true"
                label="Spots"
                :loading="loadingSpots"
                :onSearch="onSearchSpots"
            >
              <template v-slot:list_selection="{ selection }">
                {{ selection.alias_id }} {{ selection.address }}
                {{ selection.unit ? selection.unit : "" }}
                ({{ selection.user ? `${selection.user.name || ""} ${selection.user.last_name || ""}` : "" }})
              </template>
            </AutocompleteInput>
          </v-col>
          <v-col>
            <v-select
              label="Mes"
              :items="months"
              item-text="name"
              item-value="value"
              v-model="data.months"
              solo
              hide-details="auto"
              class="input-base"
               append-icon="$caretDownFormIcon"
              clearable
            >
            </v-select>
          </v-col>
          <v-col>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
              loading
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="data.year"
                  label="Año"
                  solo
                  hide-details="auto"
                  class="input-base"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-card>
                <vue-element-loading
                  background-color="white"
                  :active="load_date_picker"
                  spinner="bar-fade-scale"
                  color="#335C9D"
                />
                <v-date-picker
                  ref="picker"
                  v-model="date"
                  :active-picker="type_picker"
                  no-title
                  scrollable
                  @click:year="saveYear"
                >
                </v-date-picker>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </template>

      <template v-slot:spot_id="{ item }">
        {{ item.spot_id && item.spot_id.address ? item.spot_id.address : "" }}
        {{ item.spot_id && item.spot_id.unit ? item.spot_id.unit : "" }}
      </template>
      <template v-slot:user_id="{ item }">
        {{ item.user_id && item.user_id.name ? item.user_id.name : "" }}
        {{ item.user_id && item.user_id.last_name ? item.user_id.last_name : "" }}
      </template>
      <template v-slot:total="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{
            formatUSD(
              Number(item.total) ||
                0 /* -
              calculateCommission(item.total, item.commission_percentage) */
            )
          }}
        </p>
      </template>
      <template v-slot:total_to_liquidate="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{
            formatUSD(
              Number(item.total_to_liquidate) ||
                0 /* -
              calculateCommission(item.total, item.commission_percentage) */
            )
          }}
        </p>
      </template>
      <template v-slot:coins_to_host="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{
            formatMiles(
                Number(item.coins_to_host) || Number(item.total_to_liquidate) || 0
            )
          }}
        </p>
      </template>
      <template v-slot:commission="{ item }">
        <p class="mb-0 text-right text-no-wrap">
          {{
            formatUSD(
              calculateCommission(item.total, item.commission_percentage)
            )
          }}
        </p>
      </template>
      <template v-slot:commission_percentage="{ item }">
        % {{ item.commission_percentage || 0 }}
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import { mapState } from "vuex";
import AutocompleteInput from "@/components/AutocompleteInput";
import VueElementLoading from "vue-element-loading";
import { format } from "currency-formatter";
import debounce from "lodash/debounce";
export default {
  components: { CrudList, AutocompleteInput, VueElementLoading },
  data: () => ({
    date: new Date().toISOString().substr(0, 4),
    menu: false,
    modal: false,
    type_picker: "YEAR",
    load_date_picker: false,
    offsetTop: 0,
    filters: {
      users_spot: [],
      months: null,
      spots: [],
      year: null,
    },
    data: {
      users_spot: [],
      months: null,
      spots: [],
      year: null,
    },
    isRead:false,
    loadingUsers: false,
    loadingSpots: false,
    months: [
      { name: "Enero", value: 1 },
      { name: "Febrero", value: 2 },
      { name: "Marzo", value: 3 },
      { name: "Abril", value: 4 },
      { name: "Mayo", value: 5 },
      { name: "Junio", value: 6 },
      { name: "Julio", value: 7 },
      { name: "Agosto", value: 8 },
      { name: "Septiembre", value: 9 },
      { name: "Octubre", value: 10 },
      { name: "Noviembre", value: 11 },
      { name: "Diciembre", value: 12 },
    ],
  }),
  computed: {
    ...mapState({
      users: (state) => state.Users.list,
      spots: (state) => state.Spots.list,
    }),
    displayUsers() {
      if (this.loadingUsers) {
        // Retornamos un item ficticio con _loading
        return [{ _loading: true, full_name: "Buscando..." }];
      }
      return this.users;
    },
    displaySpots() {
      if (this.loadingSpots) return [{ _loading: true, address: "Buscando..." }];
      return this.spots;
    }
  },
  watch: {
    "data.users_spot"(val) {
      this.filters.users_spot = val;
      this.$store.dispatch("Spots/getListAll", {
        users: val,
      });
    },
    "data.spots"(val) {
      this.filters.spots = val;
    },
    "data.months"(val) {
      this.filters.months = val;
    },
    "data.year"(val) {
      this.filters.year = val;
    },
    menu(val) {
      if (val) {
        this.load_date_picker = true;
        this.$nextTick(() => {
          this.type_picker = "MONTH";
          setTimeout(() => {
            this.type_picker = "YEAR";
            setTimeout(() => (this.load_date_picker = false), 200);
          }, 100);
        });
      }
    },
  },
  created() {
    // Inicializa con lista vacía o los 10 primeros usuarios
    this.$store.dispatch("Users/getListAll", {
      search: "",
      limit: 10,
      sorting_column: "name",
    });
    this.$store.dispatch("Spots/getListAll", {
      search: "",
      limit: 10,
      sorting_column: "name",
    });
    this.data.users_spot = [];
    this.data.spots = [];
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    getAutocompleteUsers(users) {
      this.data.users_spot = users;
    },
    getAutocompleteSpots(spots) {
      this.data.spots = spots;
    },
    showItem(item) {
      let address = item.address || "";
      if (address.length > 25) address = address.substring(0, 25) + "...";
      return `${address} (${item.user ? `${item.user.name || ""} ${item.user.last_name || ""}` : ""})`;
    },
    onSearchSpots(query) {
      if (!query || query.length < 2) return;

      this.loadingSpots = true;
      this.debouncedSearchSpots(query);
    },
    debouncedSearchSpots: debounce(async function(query) {
      try {
        await this.$store.dispatch("Spots/getListAll", { search: query, limit: 30 });
      } finally {
        this.loadingSpots = false;
      }
    }, 300),
    filterSpot(item, query, item_text) {
      const q = query.toLowerCase();
      return (
          (item[item_text] && item[item_text].toLowerCase().includes(q)) ||
          (item.user && item.user.name && item.user.name.toLowerCase().includes(q)) ||
          (item.user && item.user.last_name && item.user.last_name.toLowerCase().includes(q)) ||
          (item.alias_id && item.alias_id.toString().includes(q))
      );
    },
    onSearchUsers: function(query) {
      if (!query || query.length < 2) return;

      // Activamos el loader inmediatamente
      this.loadingUsers = true;

      // Llamada a la función debounced que hace la búsqueda
      this.debouncedSearch(query);
    },

    debouncedSearch: debounce(async function(query) {
      try {
        await this.$store.dispatch("Users/getListAll", {
          search: query,
          limit: 30,
          sorting_column: "name",
        });
      } finally {
        this.loadingUsers = false;
      }
    }, 300),
    filterObject(item, query, text) {
      return item[text] && item[text].toLowerCase().includes(query.toLowerCase());
    },
    saveYear(year) {
      this.$refs.menu.save(year);
      this.type_picker = "MONTH";
      this.data.year = year;
      this.menu = false;
    },
    formatUSD(value) {
      return format(Number(value).toFixed(2), {
        code: "USD",
        decimal: ",",
        thousand: ".",
        format: "%s %v",
      });
    },
    formatMiles(value) {
      return format(Number(value), {
        precision: 0,   // 👈 sin decimales
        thousand: ".",  // separador de miles
        decimal: ",",   // separador decimal (no se usa con 0 decimales)
      });
    },
    calculateCommission(total, percentage) {
      const percent = (percentage ? Number(percentage) : 0) / 100;
      return (total ? Number(total) : 0) * percent;
    },
  },
};
</script>
